import { useQuery } from '@tanstack/react-query';

import { buildGetRequest } from '@/hooks/base_hooks';
import type { TenantSurveyProgress } from '@/types/survey';

/**
 * GET /api/survey/<slug>/tenant-progress/ - Aggregated completion by tenant.
 * Returns null on 404 to keep the perfil page resilient while loading new backend versions.
 */
export function useTenantSurveyProgress(slug: string) {
  const queryKey = ['survey', slug, 'tenant-progress'];

  return useQuery({
    queryKey,
    queryFn: async (): Promise<TenantSurveyProgress | null> => {
      if (!slug) return null;
      const request = buildGetRequest(['survey', slug, 'tenant-progress'], {});
      try {
        return (await request()) as TenantSurveyProgress;
      } catch (err: unknown) {
        const status = (err as { response?: { status?: number } })?.response?.status;
        if (status === 404) return null;
        throw err;
      }
    },
    enabled: !!slug,
  });
}
